export { default as ProductPrice } from './productPrice'



// WEBPACK FOOTER //
// ./src/modules/productTile/productPrice/index.js